/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeValidationRpc
 */
import * as References from './PersonalizeValidationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeValidationRpc#validatePersonalizationPrerequisites
 */
export const VALIDATE_PERSONALIZATION_PREREQUISITES_QUERY_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeValidationRpc_validatePersonalizationPrerequisites';
export const VALIDATE_PERSONALIZATION_PREREQUISITES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: VALIDATE_PERSONALIZATION_PREREQUISITES_QUERY_FIELD_NAME,
  args: ['validateGenAi', 'assetSources', 'assetCoordinates'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.validatePersonalizationPrerequisitesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});